export const renderCheckboxOrHidden = (dataUser, salary) => {
  const conditionLaborUnion = dataUser?.laborUnion !== 2 && dataUser?.laborUnion !== 4;

  const workForceOk = salary
    ? salary.workForce > 10
    : dataUser?.workForce === "moreThan10";

  return conditionLaborUnion && workForceOk;
};
